"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

var _clientAwsS = require("@devsta/client-aws-s3");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function resolveProfileImages(_x, _x2) {
  return _resolveProfileImages.apply(this, arguments);
}

function _resolveProfileImages() {
  _resolveProfileImages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(outputs, apiClient) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (outputs.length) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", outputs);

          case 2:
            _context.prev = 2;
            return _context.abrupt("return", (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
              apiClient: apiClient,
              dataArray: outputs.map(function (output) {
                return _objectSpread(_objectSpread({}, output), {}, {
                  organisationId: output.video.organisationId
                });
              }),
              substitutedKeys: [{
                key: 'video',
                subKeys: [{
                  key: 'creator',
                  subKeys: ['imageUrl']
                }]
              }]
            }));

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", outputs.map(function (output) {
              var creator = (0, _lodash.default)(output, 'video.creator', {});
              return _objectSpread(_objectSpread({}, output), {}, {
                organisationId: output.video.organisationId,
                video: _objectSpread(_objectSpread({}, output.video), {}, {
                  creator: _objectSpread(_objectSpread({}, creator), {}, {
                    imageUrl: void 0
                  })
                })
              });
            }));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 6]]);
  }));
  return _resolveProfileImages.apply(this, arguments);
}

var _default = resolveProfileImages;
exports.default = _default;